import {SafeAreaView, ScrollView, View} from 'react-native';
import React, {useEffect} from 'react';
import {CreateClass} from 'components';
import {useTheme} from 'contexts/ThemeContext';
import {observer} from 'mobx-react';
import {useCreateClassStore, useUserStore} from 'contexts/StoreContext';
import {HomeScreenProps} from '../../navigations/HomeFlow';
import {Flows} from 'navigations/Screens';
import NavigationHeaderWeb from 'components/organisms/navigationWeb';
import BreadCrumbsWeb from 'components/organisms/breadCrumbsWeb';
import styleSheet from './styles';

const CreateClassScreen = observer((props: HomeScreenProps) => {
  const styles = styleSheet(useTheme());
  const userStore = useUserStore();
  const createClassStore = useCreateClassStore();

  const {
    subject,
    language,
    group,
    subjectData,
    languageData,
    groupData,
    days,
    startDate,
    endDate,
    day,
    time,
    duration,
  } = createClassStore;

  useEffect(() => {
    userStore.getCurrentUserIfNeeded().then(async () => {
      try {
        createClassStore.getClassesMetadata();
      } catch (err) {
        console.log(err);
      }
    });
  }, []);

  const onPressCreateClass = async () => {
    await createClassStore.createClass();
    props.navigation.goBack();
  };

  return (
    <SafeAreaView style={styles.safeArea}>
      <NavigationHeaderWeb activeName={Flows.homeFlow} />

      <ScrollView style={styles.scrollView}>
        <BreadCrumbsWeb />

        <View style={styles.containerStyle}>
          <CreateClass
            subject={subject}
            language={language}
            group={group}
            startDate={startDate}
            endDate={endDate}
            duration={duration}
            subjectData={subjectData}
            languageData={languageData}
            groupData={groupData}
            selectedDays={days}
            day={day}
            time={time}
            onPressCreateClass={onPressCreateClass}
          />
        </View>
      </ScrollView>
    </SafeAreaView>
  );
});

export default CreateClassScreen;
